import PageWrapper from 'components/PageWrapper'
import { useNavigate } from 'react-router-dom'
import ErrorIcon from 'assets/icons/ErrorIcon'
import Card from 'components/Card'
import PrimaryButton from 'components/primaryButton'
import { useNewTransferStore, useSelectedAccountStore } from 'store'
import { moneyFormat } from 'utils'
import { ListItem } from './ConfirmTransfer'

const CashoutError = () => {
  const navigate = useNavigate()
  const selectedAccount = useSelectedAccountStore(
    (state) => state.selectedAccount
  )
  const entityData = useSelectedAccountStore((state) => state.entityData)
  const amount = useNewTransferStore((state) => state.amount)

  return (
    <PageWrapper title='Transferencia' viewSelected='/movimientos' noTabBar>
      <section className='flex flex-col text-center text-black items-center mx-auto justify-center sm:max-w-[22.5rem] mt-8'>
        <ErrorIcon />
        <h1 className='text-xl font-bold leading-5 my-4'>
          Ha ocurrido un error en tu <br /> solicitud de transferencia
        </h1>
        <p className='font-medium'>
          No hemos podido realizar la transferencia, volvé a intentarlo en unos
          minutos
        </p>
        <Card className='w-full bg-white py-2 px-4 mt-4'>
          <ul className='w-full text-left divide-y-2 divide-gray-500'>
            <ListItem name='Monto' value={moneyFormat(amount)} />
            <ListItem
              name='Destino'
              value={selectedAccount.CVU || selectedAccount.CBU}
            />
            <ListItem
              name='Banco'
              value={
                <span className='flex gap-1'>
                  {!!entityData.iconURL && (
                    <>
                      <img
                        className='rounded-full h-5 w-5'
                        src={entityData.iconURL}
                        alt=''
                      />{' '}
                    </>
                  )}
                  {entityData.bankName}
                </span>
              }
            />
          </ul>
        </Card>
        <PrimaryButton
          className='mt-8'
          buttonText='Volver a intentar'
          primaryButtonFunction={() =>
            navigate('/transferencias/confirmar-transferencia', {
              replace: true
            })
          }
        />
        <PrimaryButton
          outlined
          className='mt-4 mb-8'
          buttonText='Cancelar'
          primaryButtonFunction={() =>
            navigate('/transferencias', { replace: true })
          }
        />
      </section>
    </PageWrapper>
  )
}

export default CashoutError
